export type BillingGateStrategy = 'onboarding' | 'in_app';
export const BILLING_GATE_STRATEGY: BillingGateStrategy = 'in_app';
